var RENDERS;
(function (RENDERS) {
    RENDERS["PN"] = "PN.render";
    RENDERS["AN_UNSTANDARD"] = "AN_UNSTANDARD.render";
    RENDERS["AN_STANDARD"] = "AN_STANDARD.render";
    RENDERS["ANC_ADD"] = "ANC_ADD.render";
    RENDERS["TITLE"] = "TITLE.render";
    RENDERS["ARRAY_LINK"] = "ARRAY_LINK.render";
    RENDERS["LEGAL"] = "LEGAL.render";
    RENDERS["CITED"] = "CITED.render";
    RENDERS["PRIORITY"] = "PRIORITY.render";
    RENDERS["INPADOC"] = "INPADOC.render";
    RENDERS["CHEMICAL"] = "CHEMICAL.render";
    RENDERS["COMMENT"] = "COMMENT.render";
    RENDERS["PV"] = "PV.render";
    RENDERS["SINGLE_LINK"] = "SINGLE_LINK.render";
    RENDERS["THUMB_120"] = "THUMB_120.render";
    RENDERS["ABST"] = "ABST.render";
    RENDERS["SORT_SEQ_NUM"] = "SORT_SEQ_NUM.render";
    RENDERS["FAMILY_NUM"] = "FAMILY_NUM.render";
    RENDERS["ARRAY"] = "ARRAY.render";
    RENDERS["CLASSIFICATION"] = "CLASSIFICATION.render";
    RENDERS["CLASSIFICATION_MAIN"] = "CLASSIFICATION_MAIN.render";
    RENDERS["CLASSIFICATION_TAG"] = "CLASSIFICATION_TAG.render";
    RENDERS["COUNTRY"] = "COUNTRY.render";
    RENDERS["MCLMS"] = "MCLMS.render";
    RENDERS["PATENT_TYPE"] = "PATENT_TYPE.render";
    RENDERS["TARGET_SEQUENCE"] = "TARGET_SEQUENCE.render";
    RENDERS["TARGET_SEQUENCE_CLAIM"] = "TARGET_SEQUENCE_CLAIM.render";
    RENDERS["TARGET_SEQUENCE_CLAIM_POSITION"] = "TARGET_SEQUENCE_CLAIM_POSITION.render";
    RENDERS["TARGET_SEQUENCE_CLAIM_TEXT"] = "TARGET_SEQUENCE_CLAIM_TEXT.render";
    RENDERS["EFFICIENCY_SENTENCE"] = "EFFICIENCY_SENTENCE.render";
    RENDERS["CLAIM_COUNT"] = "CLAIM_COUNT.render";
    RENDERS["IMAGE_COMMENTS_LAB"] = "IMAGE_COMMENTS_LAB.render";
    RENDERS["PHS_PATENTED_DRUG"] = "PHS_PATENTED_DRUG.render";
    RENDERS["PHS_CORE_TYPE_ID"] = "PHS_CORE_TYPE_ID.render";
    RENDERS["PHS_CORE_DRUG_SOURCE"] = "PHS_CORE_DRUG_SOURCE.render";
    RENDERS["TARGET_SEQUENCE_QUERY"] = "TARGET_SEQ_QUERY.render";
    RENDERS["NEV"] = "NEV.render";
    RENDERS["SAVED_TO_WORKSPACE"] = "FOLDERS.render";
})(RENDERS || (RENDERS = {}));
export const PATENT_COLUMNS_MAP = {
    PN: {
        width: 220,
        renderer: RENDERS.PN,
    },
    AN: {
        renderer: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    ANC_ADD: {
        renderer: RENDERS.ANC_ADD,
        width: 240,
    },
    TITLE: {
        width: 300,
        renderer: RENDERS.TITLE,
    },
    IN: {
        renderer: RENDERS.ARRAY_LINK,
        width: 200,
    },
    LEGAL_STATUS: {
        renderer: RENDERS.LEGAL,
        width: 160,
    },
    PRIORITY: {
        renderer: RENDERS.PRIORITY,
        width: 400,
    },
    ANC: {
        renderer: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    ANS: {
        renderer: RENDERS.AN_STANDARD,
        width: 200,
    },
    ANCS: {
        renderer: RENDERS.AN_STANDARD,
        width: 200,
    },
    DOCDB_AN: {
        renderer: RENDERS.AN_UNSTANDARD,
        width: 200,
    },
    AT: {
        renderer: RENDERS.ARRAY_LINK,
        width: 260,
    },
    ATC: {
        renderer: RENDERS.ARRAY_LINK,
        width: 260,
    },
    ATCS: {
        renderer: RENDERS.ARRAY_LINK,
        width: 260,
    },
    IN_ST: {
        renderer: RENDERS.ARRAY_LINK,
        width: 260,
    },
    IPC: {
        renderer: RENDERS.CLASSIFICATION,
        width: 360,
    },
    IPC_M: {
        renderer: RENDERS.CLASSIFICATION_MAIN,
        width: 360,
    },
    LOC: {
        renderer: RENDERS.CLASSIFICATION,
        width: 260,
    },
    UPC: {
        renderer: RENDERS.CLASSIFICATION,
        width: 260,
    },
    CPC: {
        renderer: RENDERS.CLASSIFICATION,
        width: 360,
    },
    CPC_M: {
        renderer: RENDERS.CLASSIFICATION_MAIN,
        width: 360,
    },
    CPC_ALL: {
        renderer: RENDERS.CLASSIFICATION,
        width: 360,
    },
    GBC: {
        renderer: RENDERS.CLASSIFICATION,
        width: 260,
    },
    VPM_ED: {
        renderer: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    ADC: {
        renderer: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    TTC: {
        renderer: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    SEIC: {
        renderer: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    SEIC_ALL: {
        renderer: RENDERS.CLASSIFICATION_TAG,
        width: 260,
    },
    CITE_COUNT: {
        renderer: RENDERS.CITED,
    },
    CITED_COUNT: {
        renderer: RENDERS.CITED,
    },
    SIMPLE_FAMILY_COUNT: {
        renderer: RENDERS.INPADOC,
        width: 200,
    },
    EXTEND_FAMILY_COUNT: {
        renderer: RENDERS.INPADOC,
        width: 200,
    },
    INPADOC_FAMILY_COUNT: {
        renderer: RENDERS.INPADOC,
        width: 200,
    },
    CHEMICAL_STRUCTURE: {
        width: 150,
        renderer: RENDERS.CHEMICAL,
    },
    AN_ADD: {
        isLink: true,
    },
    APN: {
        renderer: RENDERS.FAMILY_NUM,
        width: 190,
    },
    PV: {
        renderer: RENDERS.PV,
    },
    APD: {
        sortable: 'custom',
        width: 100,
    },
    PBD: {
        sortable: 'custom',
        width: 100,
    },
    F_PBD: {
        width: 100,
    },
    EXPD: {
        width: 100,
    },
    WS_CREATED_AT: {
        width: 100,
    },
    ABST: {
        renderer: RENDERS.ABST,
        width: 600,
    },
    THUMB_120: {
        renderer: RENDERS.THUMB_120,
        tools: ['viewThumb', 'searchImage'],
    },
    COMMENT: {
        width: 250,
        renderer: RENDERS.COMMENT,
    },
    SORT_SEQ_NUM: {
        renderer: RENDERS.SORT_SEQ_NUM,
        width: 215,
    },
    C_STRING: {
        width: 250,
    },
    C_OPTION: {
        width: 180,
    },
    C_URL: {
        width: 160,
    },
    WS_ASSIGN_TO: {
        renderer: RENDERS.ARRAY,
        width: 200,
    },
    EFAM_COUNTRY: {
        renderer: RENDERS.COUNTRY,
        width: 200,
    },
    SIMPLE_FAMILY_COUNTRY: {
        renderer: RENDERS.COUNTRY,
        width: 200,
    },
    MCLMS: {
        renderer: RENDERS.MCLMS,
        width: 600,
    },
    PATENT_TYPE: {
        renderer: RENDERS.PATENT_TYPE,
        width: 100,
    },
    TARGET_SEQUENCE: {
        renderer: RENDERS.TARGET_SEQUENCE,
        width: 400,
    },
    TARGET_SEQUENCE_CLAIM: {
        renderer: RENDERS.TARGET_SEQUENCE_CLAIM,
        width: 400,
    },
    TARGET_SEQUENCE_CLAIM_POSITION: {
        renderer: RENDERS.TARGET_SEQUENCE_CLAIM_POSITION,
        width: 200,
    },
    TARGET_SEQUENCE_CLAIM_TEXT: {
        renderer: RENDERS.TARGET_SEQUENCE_CLAIM_TEXT,
        width: 400,
    },
    EFFICIENCY_SENTENCE: {
        renderer: RENDERS.EFFICIENCY_SENTENCE,
        width: 600,
    },
    CLAIM_COUNT: {
        renderer: RENDERS.CLAIM_COUNT,
        width: 90,
    },
    IMAGE_COMMENTS_LAB: {
        renderer: RENDERS.IMAGE_COMMENTS_LAB,
        width: 90,
    },
    FI: {
        renderer: RENDERS.ARRAY_LINK,
        width: 260,
    },
    FTERM: {
        renderer: RENDERS.ARRAY_LINK,
        width: 260,
    },
    OREF_COUNT: {
        renderer: RENDERS.CITED,
    },
    PHS_PATENTED_DRUG: {
        renderer: RENDERS.PHS_PATENTED_DRUG,
        width: 194,
    },
    PHS_CORE_TYPE_ID: {
        renderer: RENDERS.PHS_CORE_TYPE_ID,
        width: 194,
    },
    PHS_CORE_DRUG_SOURCE: {
        renderer: RENDERS.PHS_CORE_DRUG_SOURCE,
        width: 194,
    },
    FAMILY_ID: {
        renderer: RENDERS.FAMILY_NUM,
        width: 224,
    },
    INPADOC_FAMILY_ID: {
        renderer: RENDERS.FAMILY_NUM,
        width: 224,
    },
    EXTEND_FAMILY_ID: {
        renderer: RENDERS.FAMILY_NUM,
        width: 224,
    },
    TARGET_SEQUENCE_QUERY: {
        renderer: RENDERS.TARGET_SEQUENCE_QUERY,
        width: 300,
    },
    NEV: {
        renderer: RENDERS.NEV,
        width: 260,
    },
    SAVED_TO_WORKSPACE: {
        renderer: RENDERS.SAVED_TO_WORKSPACE,
        width: 200,
    },
};
